import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

const welcomeAnimations = () => {

  const wrapper = document.querySelector('.welcome-bg');
  if (!wrapper) return;

  const mainBg = wrapper.querySelector('.main-bg');
  const groups = [...wrapper.querySelectorAll('.group')];
  const solos = [...wrapper.querySelectorAll('.solo')];

  let isPlaying = true;

  let mainTimeline;
  let groupsTimelines = [];
  let soloTimelines = [];

  gsap.timeline({
    defaults: {
      ease: "none"
    },
    onComplete: startAnimation
  })
    .to(mainBg, { duration: 2, autoAlpha: 1 }, "show")
    .to([groups], { duration: 1, autoAlpha: 1, stagger: 0.25 }, "show+=1")
    .to([solos], { duration: 1, autoAlpha: 1, stagger: 0.15 }, "show+=2");

  function animateMain() {

    mainTimeline = gsap.timeline({
      repeat: 1,
      yoyo: true,
      paused: true,
      onComplete() {
        gsap.delayedCall(gsap.utils.random(1, 2), () => animateMain());
      }
    });

    mainTimeline.to(mainBg, {
      duration: "random(3, 6)",
      autoAlpha: "random(0.5, 0.75)",
    });

    isPlaying && mainTimeline.play();
  }

  function animateGroup(group, idx) {

    groupsTimelines[idx] = gsap.timeline({
      repeat: 1,
      yoyo: true,
      paused: true,
      onComplete() {
        gsap.delayedCall(gsap.utils.random(idx, 1.5 + idx), () => animateGroup(group));
      }
    });

    groupsTimelines[idx].to(group, {
      duration: gsap.utils.random(0.5, 2),
      autoAlpha: gsap.utils.random(0, 0.5),
    });

    isPlaying && groupsTimelines[idx].play();
  }

  function animateSolo(solo, idx) {

    soloTimelines[idx] = gsap.timeline({
      repeat: 1,
      yoyo: true,
      paused: true,
      onComplete() {
        gsap.delayedCall(gsap.utils.random(idx, 0.5 + idx), () => animateSolo(solo));
      }
    });

    soloTimelines[idx].to(solo, {
      duration: gsap.utils.random(1, 2),
      autoAlpha: gsap.utils.random(0, 0.3),
      ease: "back.inOut(4)"
    });

    isPlaying && soloTimelines[idx].play();
  }

  function startAnimation() {
    animateMain();
    groups.length && groups.forEach((group, idx) => animateGroup(group, idx));
    solos.length && solos.forEach((solo, idx) => animateSolo(solo, idx));
  }

  function stopAnimation() {
    mainTimeline && mainTimeline.kill();
    groupsTimelines.length && groupsTimelines.forEach(el => el.kill());
    soloTimelines.length && soloTimelines.forEach(el => el.kill());
  }

  ScrollTrigger.create({
    trigger: wrapper,
    // markers: true,
    onEnter() {
      // console.log('Start');
      isPlaying = true;
    },
    onLeave() {
      // console.log('Stop');
      isPlaying = false;
      stopAnimation();
    },
    onEnterBack() {
      // console.log('Start again');
      isPlaying = true;
      startAnimation();
    },
  });

}

export { welcomeAnimations }